import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    // baseURL: `http://localhost:7280/api/`,
    baseURL: `https://rappi.invoicing.complement-it.com/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
